// extracted by mini-css-extract-plugin
module.exports = {"text":"text__kxj48","loading":"loading__2wTRP","icon":"icon__2B4_i","button-loader":"button-loader__MaYZn"};